<template>
  <f7-page no-toolbar no-navbar no-swipeback login-screen >

		<div class="logo-image">
			<img style="width:150px; " src="../../assets/images/pif-logo-clean.png" >
		</div>

		<f7-login-screen-title style="color:#c83c64;">LOGIN</f7-login-screen-title>

		<f7-list form >

			<f7-list-input
				outline
				type="text"
				placeholder="email"
				 v-model:value="user_email"
			></f7-list-input>

			<f7-list-input
				outline
				type="password"
				placeholder="Password"
				v-model:value="user_password"
			></f7-list-input>

			<br>

			<f7-button  style="margin:10px;" @keyup.enter="signIn()"  @click="signIn()" fill round large >Sign In</f7-button>

			<br>

			<f7-button  style="margin:10px;"   @click="register()" >Register</f7-button>

			<f7-button  style="margin:10px;"   @click="forgotPassword()" >Forgot Password</f7-button>

		</f7-list>


  </f7-page>
</template>

<script>


import { ApiMixin } from '../../mixins/api-mixin.js'
import { f7 } from 'framework7-vue';

export default {

   mixins: [ApiMixin],

    data() {
      return {
        user_email: '',
        user_password: '',
      };
    },

    methods: {

			signIn(){
				var self = this
				this.ApiSignIn(this.user_email, this.user_password).then(function(success){
					if(success){
						f7.preloader.show();
						self.ApiPreloadCoreData().then(function(success){
							if(success){
								f7.views.main.router.navigate('/vouchers-home/')
						 	}
						});
				 	}
				});
			},

			register(){
				f7.views.main.router.navigate('/user/register/')
			},

			forgotPassword(){
				f7.views.main.router.navigate('/user/reset-password/')
			},

		},

};
</script>
<style>

input[type=text]{
    /* -webkit-border-radius: 20px !important;
    -moz-border-radius: 20px !important;
     border-radius: 20px !important;
     border: 2px solid #c23464 !important;
     color: #c23464 !important;

     padding-left: 10px !important; */
}

 input[type=text]:focus {
     /* outline: none !important;
     border: 2px solid #c23464 !important;
     color: #c23464 !important;  */
}

.login-screen-page{
	/* background: #CB3867;
	background: -webkit-linear-gradient(top, #CB3867, #F3CFD6);
	background: -moz-linear-gradient(top, #CB3867, #F3CFD6);
	background: linear-gradient(to bottom, #CB3867, #F3CFD6); */
	background-image: url("../../assets/images/swish-background-doodle2.svg");
	background-size: cover;
	background-repeat:no-repeat;
	background-position: center center;


}
.login-screen-title{

}
.list-button{

}
.login-screen-content{
	background:none;
}
.logo-image{
	margin-left:calc(50% - 75px);
	width:150px;
}
</style>
